// extracted by mini-css-extract-plugin
module.exports = {"Shade":"Shade_Shade__3Yugc"};